import type { ReactElement } from 'react';
import { useCanvasSession } from '../../contexts/CanvasSessionContext';

/** Lightweight session status chip — visible after home submit during generation. */
export function SessionStatusChip(): ReactElement | null {
  const { session } = useCanvasSession();

  if (session.phase === 'idle') {
    return null;
  }

  const label =
    session.phase === 'onboarding'
      ? 'Onboarding…'
      : session.phase === 'generating'
        ? 'Generating site…'
        : session.phase === 'editing'
          ? 'Applying edit…'
          : session.phase === 'publishing'
            ? 'Publishing site…'
            : session.phase === 'complete'
              ? session.siteId
                ? `Site ready · ${session.siteId}`
                : 'Generation complete'
              : session.lastError ?? 'Session error';

  return (
    <div
      className="session-status-chip"
      data-testid="session-status-chip"
      data-phase={session.phase}
      role="status"
    >
      {label}
    </div>
  );
}
